import { createContext } from 'react'

import { UseBreakpoints, BREAKPOINTS } from './use-breakpoints'

const breakpointsCtx = createContext({} as UseBreakpoints<typeof BREAKPOINTS>)

export { breakpointsCtx }
